<template>
    <div
        class="social-auth-root d-flex mt-4 flex-column"
        style="justify-content: space-around"
    >
        <component
            v-for="socialAuth in socialAuthButtons.slice(0, 3)"
            :key="socialAuth.name"
            :is="socialAuth.comp"
            v-bind="getBindParams()"
            style="margin-top: 1.5rem;"
        />

        <b-collapse :visible="showAll" id="socialAuthButtonsCollapse">
            <div>
                <component
                    v-for="socialAuth in socialAuthButtons.slice(3)"
                    :key="socialAuth.name"
                    :is="socialAuth.comp"
                    v-bind="getBindParams()"
                    style="margin-top: 1.5rem;"
                />
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { socialAuthButtons } from '~/utils/socialAuth';

export default {
    props: {
        isLoading: Boolean,
        redirectPath: String,
        showAll: Boolean,
        queryObject: Object,
    },
    data: () => ({
        socialAuthButtons: socialAuthButtons,
    }),
    methods: {
        getBindParams() {
            return {
                redirectPath: this.redirectPath,
                queryObject: this.queryObject,
            };
        },
        onLogIn() {
            this.$emit('login');
        },
        handleError(errorMessage) {
            this.$interfaces.messageModule.addNewMessage({
                title: 'Error',
                message: errorMessage,
                state: 'ERROR',
            });
        },
        handleLoadingChange(value) {
            this.$emit('loadingChanged', value);
        },
        toggleShowMoreLoginOptions() {
            this.showMoreLoginOptions = !this.showMoreLoginOptions;
        },
    },
};
</script>

<style scoped>
/* .social-auth-root > *:not(:first-child) {
    margin-top: 1.5rem;
} */

.show-options-btn {
    display: block;
    margin: auto;
}

.show-options-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
}
</style>
